var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearTextButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ClearTextButton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ClearTextButton",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#848484",
    cx: 10,
    cy: 10,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8119312,14.8170262 C14.6947564,14.9341798 14.5358047,15 14.3700609,15 C14.204317,15 14.0453653,14.9341798 13.9281905,14.8170262 L9.9944877,10.885635 L6.06440639,14.8136253 C5.81999318,15.0553072 5.426138,15.0542557 5.18302024,14.8112722 C4.93990248,14.5682887 4.93886429,14.1746649 5.18069693,13.9304039 L9.11090312,10.0025384 L5.18141499,6.07535941 C4.94340269,5.83051949 4.946205,5.4400462 5.18770691,5.19864356 C5.42920882,4.95724092 5.8199112,4.95437128 6.06493713,5.19220045 L9.99458136,9.11934828 L13.9275037,5.18876828 C14.0846487,5.02753211 14.3164521,4.9632851 14.5342432,5.02060336 C14.7520344,5.07792162 14.9221124,5.24793577 14.9794182,5.46561109 C15.036724,5.6832864 14.9723901,5.91493998 14.8110258,6.07195844 L10.878322,10.0025384 L14.8120249,13.9339297 C14.929212,14.0510348 14.9950404,14.2098764 14.9950228,14.3754973 C14.9950052,14.5411183 14.9291432,14.6999459 14.8119312,14.8170262 Z",
    id: "CloseIcon",
    fill: "#848484",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearTextButton);
export default __webpack_public_path__ + "static/media/ClearTextButton.aa70fd74c5fc17b8c737709a52ee8498.svg";
export { ForwardRef as ReactComponent };